/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".form-bottom-actions[_ngcontent-%COMP%]{display:flex;justify-content:flex-end;margin-top:calculate_vw(30)}"];
export { styles as styles };
